import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import * as routerActions from 'connected-react-router'
import { GlobalHotKeys } from 'react-hotkeys'
import { parse, stringify } from 'querystringify'

// Actions
import { actions as authActions } from 'modules/auth/actions'

// Utils
import mapValues from 'keymap'

const GlobalShortcuts = (): JSX.Element => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { modal, ...query } = parse(location.search) as { modal: string }

  return (
    <GlobalHotKeys
      allowChanges
      keyMap={mapValues}
      handlers={{
        TOGGLESHORTCUTS: (e: KeyboardEvent | undefined) => {
          if (e?.metaKey) {
            return false
          }
          const newQuery = {
            ...query,
            ...(modal && modal === 'shortcuts' ? {} : { modal: 'shortcuts' }),
          }
          return dispatch(
            routerActions.push({
              pathname: location.pathname,
              search: stringify(newQuery),
            }),
          )
        },
        SHOWADMINMODE: () => {
          return dispatch(authActions.toggleAdminMode())
        },
      }}
    />
  )
}

export default GlobalShortcuts
